import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Settings } from "lucide-react";
import { useDismissPopover } from "../hooks/useDismissPopover";
import { DISPLAY_OPTIONS, type DisplayOption } from "../lib/displayOptions";

export function DisplayOptionsPopover() {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState<{ top: number; right: number } | null>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const panelRef = useRef<HTMLDivElement>(null);

  useDismissPopover({
    open,
    triggerRef,
    panelRef,
    onDismiss: () => setOpen(false),
  });

  const toggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!open) {
      const r = e.currentTarget.getBoundingClientRect();
      setPos({ top: r.bottom + 4, right: window.innerWidth - r.right });
    }
    setOpen((o) => !o);
  };

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className="topbar__display-options-btn"
        onClick={toggle}
        aria-label="Display options"
      >
        <Settings size={14} aria-hidden />
      </button>
      {open &&
        pos &&
        createPortal(
          <div
            ref={panelRef}
            className="display-options-popover"
            style={{ top: pos.top, right: pos.right }}
          >
            {DISPLAY_OPTIONS.map((option) => (
              <DisplayOptionRow key={option.id} option={option} />
            ))}
          </div>,
          document.body,
        )}
    </>
  );
}

function DisplayOptionRow({ option }: { option: DisplayOption }) {
  const value = option.useValue();
  return (
    <label className="display-options-popover__row">
      <input
        type="checkbox"
        className="display-options-popover__checkbox"
        checked={value}
        onChange={(e) => option.setValue(e.target.checked)}
      />
      <span className="display-options-popover__label">{option.label}</span>
    </label>
  );
}
